import { Component, h, Prop, State, Event, EventEmitter } from '@stencil/core';
import { UserService, User } from '../aafp-authentication-wrapper/userService';
import { getClassListString } from '../component-utils/stencilUtils';

/**
 * COMPNAME is a component designed for handling authentication-specific functionality inside the global navigation menu.
 */
@Component({
  tag: 'aafp-signin',
  shadow: false,
})
export class AafpSignIn {
  /**
   * Account icon URL
   */
  @Prop({ mutable: true }) accountIconLink: string = '';
  /**
   * Sign in link aria label
   */
  @Prop({ mutable: true }) accountIconLabel: string = '';
  /**
   * Salesforce authentication endpoint required for initializing the user service (required for loading user data)
   */
  @Prop() authEndpoint!: string;
  /**
   * URL for unauthenticated users to sign in
   */
  @Prop() loginUrl: string;
  /**
   * URL for authenticated users to sign out
   */
  @Prop() logoutUrl: string;
  /**
   * User authentication state
   */
  @Prop() isLoggedIn!: boolean;
  @State() userData: User | null;
  userService: any;

  @Event({
    eventName: 'userDataLoaded',
    composed: true,
    bubbles: true,
  })
  userDataLoaded: EventEmitter; // eslint-disable-line

  componentWillLoad() {
    this.userService = new UserService(this.authEndpoint);
    if (this.isLoggedIn) {
      this.userService.getUserData().then((userData: User | null) => {
        if (userData) {
          this.userData = userData;
          this.userDataLoaded.emit(userData);
        }
      });
    }
  }

  unauthenticatedUser() {
    return <div class="adl-signin__login-link">Log In</div>;
  }

  authenticatedUser() {
    if (this.userData) {
      return (
        <a href={this.logoutUrl} class="adl-signin__link adl-signin__logout-link">
          Log Out
        </a>
      );
    }
  }

  displayWelcomeMessage() {
    if (this.userData) {
      return <span class="adl-signin__login-text">My Account</span>;
      // return <span class="adl-signin__login-text">Welcome, {this.userData.FirstName}!</span>;
    }
  }

  render() {
    const loggedIn = this.isLoggedIn;
    const accountIconUrl = loggedIn ? this.accountIconLink : `${this.loginUrl}?redirect=${window.location.href}`;
    return (
      <div class="adl-signin">
        <div class={getClassListString({ 'adl-signin--unauthenticated': !loggedIn }, 'adl-signin__user-wrapper')}>
          <a
            class="adl-universal-nav__icon-link adl-universal-nav__link adl-signin__link"
            href={accountIconUrl}
            aria-label={this.accountIconLabel}
          >
            <i class="material-icons adl-signin__account-icon">account_circle</i>
            {loggedIn && this.displayWelcomeMessage()}
            {!loggedIn && this.unauthenticatedUser()}
          </a>
          {loggedIn && this.authenticatedUser()}
        </div>
      </div>
    );
  }
}
